var Backbone, SupportFlashTemplate, SupportFlashView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFlashTemplate = require('../../flash.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportFlashView = (function(superClass) {
  extend(SupportFlashView, superClass);

  function SupportFlashView() {
    return SupportFlashView.__super__.constructor.apply(this, arguments);
  }

  SupportFlashView.prototype.className = 'flash';

  SupportFlashView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportFlashTemplate;
    this.type = this.options.type;
    if (this.type == null) {
      this.type = 'info';
    }
    this.content = this.options.content;
    if (!this.options.sticky) {
      return delay(20000, (function(_this) {
        return function() {
          return _this.remove();
        };
      })(this));
    }
  };

  SupportFlashView.prototype.render = function() {
    this.$el.addClass(this.type);
    return this.$el.html(toHtml(this.template, this.toHash(), this.template));
  };

  SupportFlashView.prototype.events = function() {
    return {
      'click .close': 'remove'
    };
  };

  SupportFlashView.prototype.toHash = function() {
    return {
      content: this.content
    };
  };

  SupportFlashView.prototype.close = function() {};

  return SupportFlashView;

})(Backbone.View);

module.exports = SupportFlashView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZmxhc2hfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9mbGFzaF92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxJQUFBLGdEQUFBO0VBQUE7OztBQUFBLG9CQUFBLEdBQXVCLE9BQUEsQ0FBUSwyQkFBUjs7QUFDdkIsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBRVA7Ozs7Ozs7NkJBQ0osU0FBQSxHQUFXOzs2QkFFWCxVQUFBLEdBQVksU0FBQyxPQUFEO0lBQ1YsSUFBQyxDQUFBLE9BQUQsR0FBVyxPQUFBLElBQVc7SUFDdEIsSUFBQyxDQUFBLFNBQUQsR0FBYTtJQUNiLElBQUMsQ0FBQSxRQUFELEdBQVk7SUFDWixJQUFDLENBQUEsSUFBRCxHQUFRLElBQUMsQ0FBQSxPQUFPLENBQUM7SUFDakIsSUFBTyxpQkFBUDtNQUNFLElBQUMsQ0FBQSxJQUFELEdBQU8sT0FEVDs7SUFFQSxJQUFDLENBQUEsT0FBRCxHQUFXLElBQUMsQ0FBQSxPQUFPLENBQUM7SUFDcEIsSUFBQSxDQUFPLElBQUMsQ0FBQSxPQUFPLENBQUMsTUFBaEI7YUFDRSxLQUFBLENBQU0sS0FBTixFQUFhLENBQUEsU0FBQSxLQUFBO2VBQUEsU0FBQTtpQkFBRyxLQUFDLENBQUEsTUFBRCxDQUFBO1FBQUg7TUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBQWIsRUFERjs7RUFSVTs7NkJBV1osTUFBQSxHQUFRLFNBQUE7SUFDTixJQUFDLENBQUEsR0FBRyxDQUFDLFFBQUwsQ0FBYyxJQUFDLENBQUEsSUFBZjtXQUNBLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixJQUFDLENBQUEsTUFBRCxDQUFBLENBQWxCLEVBQTZCLElBQUMsQ0FBQSxRQUE5QixDQUFWO0VBRk07OzZCQUlSLE1BQUEsR0FBUSxTQUFBO1dBQ047TUFBQSxjQUFBLEVBQWdCLFFBQWhCOztFQURNOzs2QkFHUixNQUFBLEdBQVEsU0FBQTtXQUNOO01BQUEsT0FBQSxFQUFTLElBQUMsQ0FBQSxPQUFWOztFQURNOzs2QkFHUixLQUFBLEdBQU8sU0FBQSxHQUFBOzs7O0dBeEJzQixRQUFRLENBQUM7O0FBMkJ4QyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
